<div class="billing-control-gateway-table-modal">
  <p class="billing-control-gateway-table-modal__hint">
    Cada linha é um plano (assinatura + tipo). Cada coluna é a prioridade do gateway na cobrança.
  </p>

  <div class="billing-control-gateway-table-modal__toolbar">
    <div class="billing-control-gateway-table-modal__bulk">
      <p-dropdown
        [options]="gatewayList"
        [(ngModel)]="bulkPrimaryGatewayId"
        optionLabel="gatewayName"
        optionValue="gatewayId"
        placeholder="Gateway primário"
        [showClear]="true"
        [filter]="true"
        filterBy="gatewayName"
        appendTo="body"
        styleClass="billing-control-gateway-table-modal__bulk-dropdown"
      />
      <button
        pButton
        type="button"
        label="Aplicar como prioridade 1 em todos"
        icon="pi pi-check"
        class="p-button-outlined p-button-sm"
        [disabled]="bulkPrimaryGatewayId === null || rows.length === 0"
        (click)="applyPrimaryGatewayToAll()"
      ></button>
    </div>

    <button
      pButton
      type="button"
      label="Adicionar coluna de prioridade"
      icon="pi pi-plus"
      class="p-button-outlined p-button-sm"
      [disabled]="!canAddPriorityColumn()"
      (click)="addPriorityColumn()"
    ></button>
  </div>

  <div class="billing-control-gateway-table-modal__table-wrap" *ngIf="rows.length > 0">
    <table class="billing-control-gateway-table">
      <thead>
        <tr>
          <th class="billing-control-gateway-table__plan-col">Plano</th>
          <th *ngFor="let column of priorityColumns">
            Prioridade {{ column + 1 }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let row of rows">
          <td class="billing-control-gateway-table__plan-col">
            <span [title]="row.label">{{ row.label }}</span>
          </td>
          <td *ngFor="let column of priorityColumns">
            <p-dropdown
              [options]="getGatewayOptions(row, column)"
              [(ngModel)]="row.gatewayIds[column]"
              optionLabel="gatewayName"
              optionValue="gatewayId"
              placeholder="—"
              [showClear]="true"
              [filter]="true"
              filterBy="gatewayName"
              appendTo="body"
              styleClass="billing-control-gateway-table__dropdown"
            />
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <p class="billing-control-gateway-table-modal__empty" *ngIf="rows.length === 0">
    Nenhum plano encontrado.
  </p>

  <div class="billing-control-gateway-table-modal__actions">
    <button
      pButton
      type="button"
      label="Cancelar"
      class="p-button-text"
      [disabled]="isSaving"
      (click)="cancel()"
    ></button>
    <button
      pButton
      type="button"
      label="Salvar prioridades"
      icon="pi pi-save"
      [disabled]="isSaving || rows.length === 0"
      (click)="saveGatewayPriority()"
    ></button>
  </div>
</div>
